import { InjectionToken } from '@angular/core';

import { HistoricalTokenBalanceFacade } from './historical-token-balance.facade';

export const HISTORICAL_TOKEN_BALANCE_FACADE =
    new InjectionToken<HistoricalTokenBalanceFacade>(
        'HISTORICAL_TOKEN_BALANCE_FACADE'
    );